import React from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../contexts/CartContext";
import { useGeneral } from "../contexts/GeneralContext";
import { useAuth } from "../contexts/AuthContext";

const CartDropdown = () => {
  const navigate = useNavigate();
  const { hideCart } = useGeneral();
  const { cart, loading } = useCart();
  const { isLoggedIn } = useAuth();

  const cartItems = cart?.orderCart?.items || [];

  return (
    <div className="absolute top-16 right-0 lg:top-0 lg:right-0 mt-2 w-[320px] bg-secondary shadow-lg rounded-[12px] p-4 flex flex-col gap-4 z-[50]">
      {/* Arrow */}
      <div className="absolute -top-2 right-10 lg:right-1/2 lg:translate-x-1/2 w-4 h-4 bg-secondary rotate-45 shadow-md"></div>

      {/* Cart Items */}
      <div className="space-y-3 max-h-[300px] overflow-y-auto">
        {loading ? (
          <p className="text-white text-center text-sm">Loading...</p>
        ) : cartItems.length > 0 ? (
          cartItems.slice(-3).map((item, idx) => (
            <div
              key={idx}
              className="flex items-center gap-3 bg-white rounded-[5px] ps-2 pe-2"
            >
              <img
                src={
                  process.env.REACT_APP_BACKEND_URL +
                  "public/" +
                  item?.product?.image
                }
                onError={(e) => {
                  e.currentTarget.src = require("../../assets/images/link.png");
                }}
                alt="image"
                className="w-12 h-12 object-cover text-10pt rounded-md bg-gray"
              />
              <div className="flex-1 flex flex-col py-2">
                <span className="text-xs line-clamp-2 mb-1">
                  {item?.product?.title}
                </span>
                <span className="text-xs text-quaternary">
                  Qty: {item?.quantity}
                </span>
              </div>
              <span className="text-sm text-orange">
                {item?.product?.salePrice} AED
              </span>
            </div>
          ))
        ) : (
          <p className="text-white text-center text-sm">Your cart is empty.</p>
        )}

        {cartItems.length > 3 && (
          <p className="text-xs text-white text-center">
            And {cartItems.length - 3} more items...
          </p>
        )}
      </div>

      {/* Buttons */}
      <div className="flex flex-col gap-2 mt-0">
        {cartItems.length > 0 ? (
          <button
            className="w-full bg-orange text-white py-2 rounded-lg hover:bg-orange-600 transition"
            onClick={() => {
              navigate(isLoggedIn ? "/account/cart" : "/cart");
              hideCart();
            }}
          >
            View Cart
          </button>
        ) : (
          <button
            className="w-full bg-quaternary text-white py-2 rounded-lg hover:bg-quaternary/60 transition"
            onClick={() => {
              navigate("/shop");
              hideCart();
            }}
          >
            View Products
          </button>
        )}
        {!isLoggedIn && (
          <>
            <button
              className="w-full text-center text-orange transition hover:text-quaternary"
              onClick={() => {
                navigate("/signin");
                hideCart();
              }}
            >
              Log In
            </button>

            <button
              className="w-full text-center text-orange transition hover:text-quaternary"
              onClick={() => {
                navigate("/signup");
                hideCart();
              }}
            >
              Sign Up
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default CartDropdown;
